module.exports = __webpack_public_path__ + "img/sweat.f0dacc90.png";